// Game status vocabulary for the Adventures library.
export const GAME_STATUSES = [
  { value: "playing", label: "Currently Playing" },
  { value: "on-hold", label: "On Hold" },
  { value: "completed", label: "Completed" },
  { value: "planned", label: "Planned" },
  { value: "retired", label: "Retired" },
];

const LABELS = GAME_STATUSES.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

// Tolerant of any legacy values that may still linger.
const LEGACY = { current: "Currently Playing", upcoming: "Planned" };

export function statusLabel(value) {
  if (!value) return "";
  return LABELS[value] || LEGACY[value] || value;
}
